!((document, Drupal, $) => {

  'use strict';

  /**
   * Handle highlight message paragraph
   */
  Drupal.behaviors.paragraphHighlightMessage = {

    attach: function(context) {

      /**
       * Adjusts the paddings of previous & next paragraphs.
       *
       * @param {object} $paragraphWrapper
       *  The paragraph wrapper.
       * @param {object} $prevParagraphContainer
       *  The previous paragraph container.
       * @param {object} $nextParagraphContainer
       *  The next paragraph container.
       * @returns {void}
       */
      function adjustParagraphPaddings($paragraphWrapper, $prevParagraphContainer, $nextParagraphContainer) {
        let height = $paragraphWrapper.height();

        // Backups the original top/bottom paddings in a data attribute
        if (typeof $prevParagraphContainer.data('original-padding-bottom') === 'undefined') {
          $prevParagraphContainer.data(
            'original-padding-bottom',
            parseInt($prevParagraphContainer.css('padding-bottom')) || 0
          );
        }
        if (typeof $nextParagraphContainer.data('original-padding-top') === 'undefined') {
          $nextParagraphContainer.data(
            'original-padding-top',
            parseInt($nextParagraphContainer.css('padding-top')) || 0
          );
        }

        // Increases the top/bottom paddings.
        $prevParagraphContainer.css(
          'padding-bottom',
          $prevParagraphContainer.data('original-padding-bottom')
            + Math.max(0, Math.ceil(height * 0.75))
        );
        $nextParagraphContainer.css(
          'padding-top',
          $nextParagraphContainer.data('original-padding-top')
            + Math.max(0, Math.ceil(height * 0.25))
        );
      }

      /**
       * Overlaps the current paragraph on the 2 adjacent paragraphs.
       *
       * @param {object} $paragraph
       *  The paragraphs.
       * @returns {void}
       */
      function overlapParagraph($paragraph) {
        let paragraphSelector = '.paragraph:not(.paragraph--theme-dark)';

        let $prevParagraph = $paragraph.prev('.paragraph').length ?
          $paragraph.prev(paragraphSelector) :
          $paragraph.prev('a.visually-hidden').prev(paragraphSelector);

        let $nextParagraph = $paragraph.next('.paragraph').length ?
          $paragraph.next(paragraphSelector) :
          $paragraph.next('a.visually-hidden').next(paragraphSelector);

        if ($prevParagraph.length && $nextParagraph.length) {
          let $paragraphContainer = $paragraph.find('.wrapper').first();
          let $prevParagraphContainer = $prevParagraph.find('.layout-inner-container').first();
          let $nextParagraphContainer = $nextParagraph.find('.layout-inner-container').first();

          adjustParagraphPaddings($paragraphContainer, $prevParagraphContainer, $nextParagraphContainer);
          $paragraph.addClass('overlap');

          $(window).bind('resize', function () {
            adjustParagraphPaddings($paragraphContainer, $prevParagraphContainer, $nextParagraphContainer);
          });
        }
      }

      // eslint-disable-next-line max-len
      $(context).find('.paragraph--type-highlight-message').once('paragraphHighlightMessage').each(function () {
        let $paragraph = $(this);
        overlapParagraph($paragraph);
      });

    }

  };
// eslint-disable-next-line no-undef
})(document, Drupal, jQuery);
